import React from "react";
import { FC } from "react";
import Link from "next/link";

const BrowseHereButton = () => (
  <span className="font-medium whitespace-nowrap">Browse here</span>
);

export const NeedMoreLinkCard: FC<{
  isMobile?: boolean;
  needMoreLink?: string;
}> = ({ isMobile, needMoreLink }) => {
  const wrapperClass =
    "flex w-full items-center justify-center border bg-blog-need-more-background bg-center bg-cover border-gray-100 overflow-hidden rounded-md shadow relative";
  const buttonClass =
    "absolute border border-gray-400 rounded-md px-4 md:px-3 py-2 text-gray-600 cursor-pointer bg-white hover:bg-gray-100";

  const handleLink = () => {
    if (needMoreLink) {
      window.open(needMoreLink, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={wrapperClass}
      style={{ backgroundColor: "#f5f6f7" }}
      onClick={
        isMobile && needMoreLink !== undefined && needMoreLink.length > 0
          ? handleLink
          : undefined
      }
    >
      {/* For mobile */}
      {isMobile && needMoreLink !== undefined && needMoreLink.length > 0 ? (
        <div className={`${buttonClass} bottom-20 -translate-x-1/2`}>
          <BrowseHereButton />
        </div>
      ) : (
        <Link
          href={needMoreLink ? needMoreLink : ""}
          passHref
          target="_blank"
          rel="noopener noreferrer"
          className={`${buttonClass} transition-colors duration-200 bottom-16`}
        >
          <BrowseHereButton />
        </Link>
      )}
    </div>
  );
};
